import PropTypes from "prop-types";
import React from "react";
import injectSheet from "react-jss";
import { push } from "../../../node_modules/gatsby-link";
import ListItem from "../Navigator/ListItem";
import Article from "../Main/Article";
import Button from "@material-ui/core/Button";

const styles = theme => ({
  list: {
    listStyle: "none",
    margin: 0,
    padding: 0
  },
  blogs: {
    left: "50%",
    margin: "0 -106px",
    marginBottom: 20
  }
});

class BlogPreview extends React.Component {
  static propTypes = {
    posts: PropTypes.array.isRequired,
    children: PropTypes.node,
    classes: PropTypes.object.isRequired
  };

  render() {
    const { posts, classes, children } = this.props;

    if (posts.length === 0) {
      return (
        <Article>
          {children}
          <div className="content-0-1-32 content-0-1-28">
            <h3>Blog</h3>
            <hr />
            Wpisy w przygotowaniu...
          </div>
        </Article>
      );
    }

    return (
      <Article>
        {children}
        <Button
          className={classes.blogs}
          variant="raised"
          color="secondary"
          size="large"
          onClick={() => push("/blog/")}
        >
          Pokaż wszystkie
        </Button>
        <ul className={classes.list}>
          {posts && posts.map((post, i) => <ListItem key={i} post={post} lazyOff={true} />)}
        </ul>
      </Article>
    );
  }
}

export default injectSheet(styles)(BlogPreview);



// WEBPACK FOOTER //
// ./src/components/LandingPage/BlogPreview.js